module.exports = "/assets/971279c2083bf6e9e6a7dc0d8a5b0813.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/T4.png
// module id = 2964
// module chunks = 0